import { TextInput as MantineTextInput } from '@mantine/core'
import { UseFormRegisterReturn } from 'react-hook-form'

interface TextInputProps {
  label: string
  placeholder?: string
  required?: boolean
  error?: string
  helperText?: string
  leftSection?: React.ReactNode
  rightSection?: React.ReactNode
  className?: string
  disabled?: boolean
  type?: 'text' | 'email' | 'tel' | 'password'
  register?: UseFormRegisterReturn
  value?: string
  onChange?: (value: string) => void
}

export function TextInput({
  label,
  placeholder,
  required = false,
  error,
  helperText,
  leftSection,
  rightSection,
  className = '',
  disabled = false,
  type = 'text',
  register,
  value,
  onChange,
}: TextInputProps) {
  const inputProps = register
    ? { ...register }
    : {
        value,
        onChange: onChange
          ? (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)
          : undefined,
      }

  return (
    <div className={`space-y-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <MantineTextInput
        {...inputProps}
        placeholder={placeholder}
        disabled={disabled}
        type={type}
        leftSection={leftSection}
        rightSection={rightSection}
        error={error}
        description={helperText}
        radius="md"
        size="md"
        className="w-full"
        styles={{
          input: {
            backgroundColor: '#F5F5F7',
            border: 'none',
          },
          error: {
            fontSize: 10,
          },
        }}
      />
    </div>
  )
}
